export default {
  sourcing: {
    nav: 'Sourcing',
    title: 'Active Search',
    subtitle: 'LinkedIn candidates via Apify: search, potential assessment, outreach',
    newProject: 'New project',
    projectName: 'Project name',
    language: 'Project language',
    vacancy: 'Vacancy (for promote)',
    noVacancy: 'No vacancy',
    portrait: 'Candidate portrait (who we are looking for)',
    outreachTemplate: 'Outreach message template ({{name}} — candidate name)',
    candidates: 'candidates',
    scored: 'scored',
    create: 'Create',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    loading: 'Loading…',
    empty: 'Nothing here yet',
    error: 'Error',
    back: 'Back',
    all: 'All',

    runs: 'Runs',
    newRun: 'New run',
    importFile: 'Import from file',
    importRun: 'Import results',
    exportCsv: 'Export CSV',
    scoreAll: 'Score all (AI)',
    scoringInProgress: 'Scoring in progress — this may take a few minutes…',
    scoredResult: 'Scored: {{scored}}, failed: {{failed}}',
    importedResult: 'Imported: {{imported}}, duplicates: {{duplicates}}',
    runStatus: { queued: 'queued', running: 'running', succeeded: 'succeeded', failed: 'failed' },

    filterGrade: 'Grade',
    filterBucket: 'Bucket',
    filterStatus: 'Status',
    minScore: 'Min score',
    search: 'Search: name, company, title…',

    colName: 'Candidate',
    colRole: 'Role & company',
    colYears: 'Yrs',
    colFlags: 'Flags',
    colScore: 'Score',
    colGrade: 'Grade',
    colStatus: 'Status',
    flagFounder: 'ex-founder',
    flagFastGrowth: 'fast growth',
    flagRussian: 'russian',
    flagOpenToWork: 'open to work',
    promoted: 'in pipeline',
    markContacted: 'Mark contacted ({{count}})',

    status: {
      found: 'found',
      reviewed: 'reviewed',
      contacted: 'contacted',
      replied: 'replied',
      interested: 'interested',
      questionnaire: 'questionnaire',
      case: 'case',
      interview: 'interview',
      finalist: 'finalist',
      offer: 'offer',
      rejected: 'rejected',
      no_response: 'no response',
    },

    profile: 'Profile',
    about: 'About',
    experience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    languages: 'Languages',
    connections: 'connections',
    assessment: 'Potential assessment',
    notScored: 'Not scored yet',
    scoreNow: 'Score (AI)',
    evidence: 'Evidence',
    assumptions: 'Assumptions',
    unknowns: 'Unknowns',
    criteriaLabels: {
      entrepreneurial_drive: 'Entrepreneurial drive',
      ownership_initiative: 'Ownership & initiative',
      commercial_instinct: 'Commercial instinct',
      analytical_ability: 'Analytical ability',
      uae_market_knowledge: 'UAE market knowledge',
      leadership_potential: 'Leadership potential',
      bias_to_action: 'Bias to action',
      calculated_risk: 'Calculated risk',
      career_hunger: 'Career hunger',
    },
    requiredQuestions: 'Questions for the candidate',
    summary: 'Owner summary',
    redFlags: 'Red flags',
    manualGrade: 'Manual grade',
    outreachStatus: 'Outreach status',
    channel: 'Channel',
    notes: 'Notes',
    copyOutreach: 'Copy outreach message',
    copied: 'Copied',
    noTemplate: 'No outreach template set on the project',
    promote: 'Promote to vacancy',
    promoteConfirm: 'Create a candidate in the vacancy? Questionnaires, emails and interviews work as usual after that.',
    selectVacancy: 'Select a vacancy',
    promotedOk: 'Candidate created in pipeline',

    preset: 'Preset',
    customInput: 'Custom input',
    inputJson: 'Actor input (JSON)',
    bucket: 'Bucket',
    estCost: 'Estimated cost',
    estCostFormula: '$0.10 × pages + $0.004 × maxItems',
    start: 'Start',
    starting: 'Starting…',
    invalidJson: 'Invalid JSON',
    runStarted: 'Run created — status updates on the project page',
  },
};
